import { FC, useEffect, useState } from "react";
import dayjs, { Dayjs } from "dayjs";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { IconButton, Stack, Switch, TextField, Tooltip } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";

import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { CommissionPediodModel } from "./SetupCommission";

interface PeriodComponentProps {
    period: CommissionPediodModel;
    removePeriod: (period: CommissionPediodModel) => void;
}

const PeriodComponent: FC<PeriodComponentProps> = ({ period, removePeriod }) => {
    const [percentValue, setPercentValue] = useState<number>(0);
    const [startDate, setStartDate] = useState<Dayjs>(dayjs());
    const [endDate, setEndDate] = useState<Dayjs>(dayjs());

    const [noEndDate, setNoEndDate] = useState<boolean>(true);

    useEffect(() => {
        setPercentValue(period.percent);
        setStartDate(dayjs(period.startDate));

        if (period.endDate === null) {
            setNoEndDate(true);
            setEndDate(dayjs());
        }
        else {
            setNoEndDate(false);
            setEndDate(dayjs(period.endDate));
        }
    }, [period])

    function SetPercentValue(event: any) {
        var value = event.target.value;
        setPercentValue(value)
        period.percent = value;
    }
    function SetStartDate(param: any) {
        var value = dayjs(param).set("date", 2).add(12, "hour");
        setStartDate(value);
        period.startDate = value;
    }
    function SetEndDate(param: any) {
        var value = dayjs(param).set("date", 24).add(12, "hour");
        setEndDate(value);
        period.endDate = value;
    }

    function SetNoEndDate(event: any) {
        setNoEndDate(event.target.checked)
        period.endDate = null;
    }

    return (
        <Stack direction={"row"} spacing={2}>
            {/* Percent */}
            <Stack
                direction={"row"}
                alignItems={"center"}>
                <p style={{ width: '65px' }}>Percent: </p>
                <TextField
                    value={percentValue}
                    onChange={SetPercentValue}
                    sx={{ width: "80px" }}
                    size="small" />
            </Stack>

            {/* Start */}
            <Stack
                direction={"row"}
                alignItems={"center"}>
                <p style={{ width: '48px' }}>Start: </p>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                        format="MM/YYYY"
                        views={['year', 'month']}
                        openTo={'month'}
                        value={startDate}
                        onChange={SetStartDate}
                        sx={{ width: "130px" }} />
                </LocalizationProvider>
            </Stack>

            {/* End */}
            <Stack
                direction={"row"}
                alignItems={"center"}>
                <p style={{ width: '48px' }}>End: </p>
                <Tooltip title="Without the end date?">
                    <Switch
                        checked={noEndDate}
                        onChange={SetNoEndDate}
                        size="small" />
                </Tooltip>
                {!noEndDate ?
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            format="MM/YYYY"
                            views={['year', 'month']}
                            openTo={'month'}
                            value={endDate}
                            onChange={SetEndDate}
                            sx={{ width: "130px" }} />
                    </LocalizationProvider>
                    : null}
            </Stack>

            <IconButton
                color="error"
                size="large"
                sx={{ width: "30px", height: "30px", top: "10px" }}
                onClick={() => { removePeriod(period) }}>
                <DeleteForeverIcon />
            </IconButton>
        </Stack>
    )
}

export default PeriodComponent;